import React, { ComponentProps, FC } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import moment, { Moment } from 'moment';

import FormGroup, { IPropsText as IFormGroupTextProps } from '../components/FormGroup';

// antd v5 ships a dayjs-based picker, but this project uses moment — so we
// generate a moment-based picker, exactly like AntDatePicker does.
const MomentDatePicker = AntDatePicker.generatePicker<Moment>(momentGenerateConfig);
const MomentRangePicker = MomentDatePicker.RangePicker;

interface IRangePickerProps {
  fromName: string;
  toName: string;
  from?: Moment | string | null;
  to?: Moment | string | null;
  onChange?: (event: { target: { name: string; value: any | null } }) => void;
}

export type IProps = IFormGroupTextProps &
  IRangePickerProps &
  Omit<ComponentProps<typeof MomentRangePicker>, 'onChange' | 'value' | 'defaultValue'>;

// Диапазон дат. В отличие от одиночного пикера, отдаёт два значения (from/to),
// поэтому пишет их обратно в фильтр как два отдельных поля через стандартный
// контракт onChange ({ target: { name, value } }).
const RangePicker: FC<IProps> = ({
  label,
  tooltip,
  description,
  fromName,
  toName,
  from,
  to,
  onChange,
  ...props
}) => {
  const handleChange = (dates: [Moment | null, Moment | null] | null) => {
    if (!onChange) return;
    onChange({ target: { name: fromName, value: dates ? dates[0] : null } });
    onChange({ target: { name: toName, value: dates ? dates[1] : null } });
  };

  return (
    <FormGroup label={label} description={description} tooltip={tooltip}>
      <MomentRangePicker
        style={{ width: '100%' }}
        value={[from ? moment(from) : null, to ? moment(to) : null]}
        onChange={handleChange}
        {...props}
      />
    </FormGroup>
  );
};

export default RangePicker;
